import React, { useState } from 'react';
import { BringzzButton, BringzzImage, BringzzText } from "@bringzz/components";
import { useNavigation } from 'context/NavigationContext';
import {
	BringzzPageContainer,
	BringzzIcon,
	BringzzRadioList,
	BringzzCountryDropdown,
	BringzzInput
} from "@bringzz/components";
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import WAVE_IMAGE from 'assets/images/wave.png'

const AllowWhatsappPage = () => {
	const { backPress } = useNavigation();
	const { navigate } = useNavigation();
	const { t } = useTranslation();

	return (
		<BringzzPageContainer
			className="bg-white"
			steps={true}
			activeStep={6}
			header={{
				left: (
					<BringzzIcon
						size='22'
						icon='IconChevronLeft'
						folder='LineIcons'
						className='cursor-pointer'
						onClick={backPress}
					/>
				),
				title: t('component.auth.consumer.whatsapp.header.title'),
				right: <BringzzButton size='sm' className="border border-black" onClick={() => {
					navigate('/register/tracking');
				}}>{t('component.auth.consumer.whatsapp.header.skip')}</BringzzButton>
			}}
			footer={
				<div className='pb-8 px-6'>
					<BringzzButton
						size='lg'
						className='bg-magic-lilac w-full flex justify-center text-midnight-blue'
						onClick={() => {
							navigate('/register/tracking')
						}}
					>
						{t('component.auth.consumer.whatsapp.buttons.allow')}
					</BringzzButton>
				</div>
			}
			authenticated={false}
		>
			<div className='relative flex justify-center bg-magic-lilac/20'>
				<div className='relative bg-white w-full bg-cover bg-center flex flex-col'>
					{/* Content */}
					<div className='flex-grow flex flex-col py-8 px-4'>
						<div className='z-10 flex flex-col '>
							<div className='pl-2 flex flex-col space-y-6 md:max-w-lg lg:max-w-xl xl:max-w-2xl'>
								<BringzzText tag='h1' className='pl-2 text-midnight-blue font-bold'>
									{t('component.auth.consumer.whatsapp.title')}
								</BringzzText>
								<BringzzText tag="h5" className="font-normal">{t('component.auth.consumer.whatsapp.subtitle')}</BringzzText>
							</div>
							<BringzzImage className='p-8 mt-4' src={WAVE_IMAGE}></BringzzImage>
						</div>
					</div>
				</div>
			</div >
		</BringzzPageContainer >
	);
};

export default AllowWhatsappPage;
